export enum GDPRCommunicationChannel {
  Verbal = "Verbal",
  Email = "Email",
  Self = "Self",
  MobileApp = "MobileApp",
  InterestForm = "InterestForm",
  UnfitAction = "UnfitAction",
  NotDefined = "NotDefined"
}
